import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setCustomError } from '../../../actions/errorsActions'
import { ESTABLISHED, START_UP } from '../../../constants/CompanyType'
import { EFFORT_LEVEL_A, EFFORT_LEVEL_B, EFFORT_LEVEL_C } from '../../../constants/EffortLevel'

const Stars = ({ handleChange, contact }) => {
  const [isStar, setIsStar] = useState({})
  const [isDisabled, setIsDisabled] = useState(false)
  const [selectedValue, setSelectedValue] = useState()
  const dispatch = useDispatch()

  useEffect(() => {
    // temp disable for start ups
    if (contact.companyTypeId === ESTABLISHED || contact.companyTypeId === START_UP) {
      setIsDisabled(true)
    }
    if (
      (contact.numberOfTrucks <= 35 && contact.companyTypeId === ESTABLISHED) ||
      (contact.numberOfTrucks <= 2 && contact.companyTypeId === START_UP)
    ) {
      handleChange({ id: EFFORT_LEVEL_C }, 'effortLevel')
      setSelectedValue(EFFORT_LEVEL_C)
      setIsStar({ star1: true, star2: false, star3: false })
    } else if (
      (contact.numberOfTrucks >= 36 && contact.numberOfTrucks <= 75 && contact.companyTypeId === ESTABLISHED) ||
      (contact.numberOfTrucks >= 3 && contact.numberOfTrucks <= 4 && contact.companyTypeId === START_UP)
    ) {
      handleChange({ id: EFFORT_LEVEL_B }, 'effortLevel')
      setSelectedValue(EFFORT_LEVEL_B)
      setIsStar({ star1: true, star2: true, star3: false })
    } else if (
      (contact.numberOfTrucks >= 76 && contact.companyTypeId === ESTABLISHED) ||
      (contact.numberOfTrucks >= 5 && contact.companyTypeId === START_UP)
    ) {
      handleChange({ id: EFFORT_LEVEL_A }, 'effortLevel')
      setSelectedValue(EFFORT_LEVEL_A)
      setIsStar({ star1: true, star2: true, star3: true })
    }
  }, [])

  const handleStarClick = (e, name) => {
    if (!isDisabled) {
      setSelectedValue(e)
      handleChange({ id: e }, 'effortLevel')
      if (name === 'first') {
        setIsStar({ star1: true, star2: false, star3: false })
      }
      if (name === 'second') {
        setIsStar({ star1: true, star2: true, star3: false })
      }
      if (name === 'third') {
        setIsStar({ star1: true, star2: true, star3: true })
      }
    } else {
      dispatch(
        setCustomError(
          'effortLevel',
          'You are not allowed to change the effort level. Please change number of trucks if you want effort level to be changed.(0-35 C, 36-75 B, 76+ A)'
        )
      )
    }
  }
  return (
    <>
      <div className='customStars'>
        <span
          value='1'
          onClick={() => handleStarClick(EFFORT_LEVEL_C, 'first')}
          className={`fa fa-star ${isStar.star1 ? 'checked' : ''}`}
        ></span>
        <span
          value='2'
          onClick={() => handleStarClick(EFFORT_LEVEL_B, 'second')}
          className={`fa fa-star ${isStar.star2 ? 'checked' : ''}`}
        ></span>
        <span
          value='3'
          onClick={() => handleStarClick(EFFORT_LEVEL_A, 'third')}
          className={`fa fa-star ${isStar.star3 ? 'checked' : ''}`}
        ></span>
      </div>
      <div className='caption'>
        {selectedValue ? '' : <span className='label label-default'>Not Rated</span>}
        {selectedValue === EFFORT_LEVEL_A && <span className='label label-info'>A</span>}
        {selectedValue === EFFORT_LEVEL_B && <span className='label label-warning'>B</span>}
        {selectedValue === EFFORT_LEVEL_C && <span className='label label-danger'>C</span>}
      </div>
    </>
  )
}

export default Stars
